import { Sparkles } from "lucide-react";
import Link from "next/link";
import { JSX } from "react";

import { Button } from "@/components/ui/button";
import routes from "@/lib/routes";
import { cn } from "@/lib/utils";

interface TakeQuizButtonProps {
  className?: string;
  dataTestId?: string;
}

export function TakeQuizButton({
  className,
  dataTestId,
}: TakeQuizButtonProps): JSX.Element {
  return (
    <Button
      asChild
      className={cn(
        "bg-gradient-to-r from-accent-purple to-info hover:from-accent-purple-hover hover:to-info-hover text-primary-foreground font-semibold",
        className,
      )}
      data-testid={dataTestId}
    >
      <Link href={routes.getProfileQuiz()}>
        <Sparkles className="h-5 w-5 mr-2" />
        Take Your Match Quiz!
      </Link>
    </Button>
  );
}
